// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkAddToList: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 9 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M0 1.625C0 1.004.504.5 1.125.5h6.75C8.496.5 9 1.004 9 1.625v10.357a.518.518 0 0 1-.806.431L4.5 9.95.806 12.413A.52.52 0 0 1 0 11.982zm1.125-.375a.376.376 0 0 0-.375.375v9.923l3.541-2.36a.375.375 0 0 1 .418 0l3.541 2.36V1.625a.376.376 0 0 0-.375-.375z"
            />
        </svg>
    );
};

export default React.memo(LinkAddToList);
